import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    isLoading: false,
    userProfile: {},
    userProfileEdit: {},
    getHomeTimeTable: {},
    getUserInfo: {},
    getBaseInfo: {},
    getParamListelEctricBooks: {},
    getMyEbookList: {},
    getListClass: {},
    getListBookType: {},
    practiceActive: {},
    paramActivityList: {},
    getActivityList: {
        "status": "success",
        "data": {
            "list": [],
            "paging": {
                "pageIndex": 1,
                "pageSize": 10,
                "totalRecords": 0,
                "totalPage": 0
            }
        },
        "errors": null
    },
    getALLProvice: {},
    getListTypeSchool:{},
    dataTypePractice:[],
    dataBookGroup:[],
    dataSubject:[],
    pramPracticeChart:{},
    getProcessPracticeChart:{},
    paramLeaningProcess:{},
    dataListProcessLearing:{},
    dataOverSubjectChart:{},
    paramProcessChat:{},
    dataListProcessChat:{},
    displayDetail:true,
    changeClass :false
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};